import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ProductService } from '../shared/product.service';
import { ProductModel } from '../shared/product.model';
import { CommonModule } from '@angular/common';
import { ArrowLeft, LucideAngularModule } from 'lucide-angular';
import { ButtonComponent } from '@app/partials/form/button/button.component';
import { DailyPricingCalendarComponent } from './daily-pricing-calendar.component';
import { DailyPricingBulkUpdateComponent } from './daily-pricing-bulk-update.component';

@Component({
  selector: 'app-product-prices-calendar',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, ButtonComponent, RouterLink, DailyPricingCalendarComponent, DailyPricingBulkUpdateComponent],
  templateUrl: './product-prices-calendar.component.html',
  styleUrl: './product-prices-calendar.component.css',
})
export class ProductPricesCalendarComponent implements OnInit {
  @ViewChild(DailyPricingCalendarComponent) calendarComponent!: DailyPricingCalendarComponent;
  @ViewChild(DailyPricingBulkUpdateComponent) bulkUpdateComponent!: DailyPricingBulkUpdateComponent;

  product: ProductModel | null = null;
  protected readonly BackIcon = ArrowLeft;

  constructor(
    private route: ActivatedRoute,
    public productService: ProductService,
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.data['product']) {
      this.product = this.route.snapshot.data['product'];
    }
  }

  getDailyPrices = () => {
    return this.productService.getDailyPrices(this.product?.id || 0);
  }

  storeBulkDailyPrices = (data: any) => {
    return this.productService.storeBulkDailyPrices(this.product?.id || 0, data);
  }

  deleteBulkDailyPrices = (data: any) => {
    return this.productService.deleteBulkDailyPrices(this.product?.id || 0, data);
  }

  onBulkUpdateSuccess(): void {
    this.calendarComponent.refresh();
  }

  onPriceClick(event: { startDate: Date; endDate: Date; price: number | null }): void {
    this.bulkUpdateComponent.populateForm(event.startDate, event.endDate, event.price);
  }
}
